import { CityCoordinate } from '../types';

// Comprehensive city-to-coordinate mapping for European and international cities
// This data is based on major cities where Artelia ambassadors are likely located
const CITY_COORDINATES: Record<string, CityCoordinate> = {
  // France
  'Paris': { city: 'Paris', country: 'France', latitude: 48.8566, longitude: 2.3522 },
  'Lyon': { city: 'Lyon', country: 'France', latitude: 45.764, longitude: 4.8357 },
  'Marseille': { city: 'Marseille', country: 'France', latitude: 43.2965, longitude: 5.3698 },
  'Toulouse': { city: 'Toulouse', country: 'France', latitude: 43.6047, longitude: 1.4442 },
  'Nice': { city: 'Nice', country: 'France', latitude: 43.7102, longitude: 7.2620 },
  'Nantes': { city: 'Nantes', country: 'France', latitude: 47.2184, longitude: -1.5536 },
  'Montpellier': { city: 'Montpellier', country: 'France', latitude: 43.6110, longitude: 3.8767 },
  'Strasbourg': { city: 'Strasbourg', country: 'France', latitude: 48.5734, longitude: 7.7521 },
  'Bordeaux': { city: 'Bordeaux', country: 'France', latitude: 44.8378, longitude: -0.5792 },
  'Lille': { city: 'Lille', country: 'France', latitude: 50.6292, longitude: 3.0573 },
  'Rennes': { city: 'Rennes', country: 'France', latitude: 48.1173, longitude: -1.6778 },
  'Reims': { city: 'Reims', country: 'France', latitude: 49.2583, longitude: 4.0317 },
  'Le Havre': { city: 'Le Havre', country: 'France', latitude: 49.4944, longitude: 0.1079 },
  'Saint-Étienne': { city: 'Saint-Étienne', country: 'France', latitude: 45.4397, longitude: 4.3872 },
  'Toulon': { city: 'Toulon', country: 'France', latitude: 43.1242, longitude: 5.9280 },
  'Angers': { city: 'Angers', country: 'France', latitude: 47.4784, longitude: -0.5632 },
  'Grenoble': { city: 'Grenoble', country: 'France', latitude: 45.1885, longitude: 5.7245 },
  'Dijon': { city: 'Dijon', country: 'France', latitude: 47.3220, longitude: 5.0415 },
  'Nîmes': { city: 'Nîmes', country: 'France', latitude: 43.8367, longitude: 4.3601 },
  'Aix-en-Provence': { city: 'Aix-en-Provence', country: 'France', latitude: 43.5297, longitude: 5.4474 },
  'Brest': { city: 'Brest', country: 'France', latitude: 48.3905, longitude: -4.4861 },
  'Le Mans': { city: 'Le Mans', country: 'France', latitude: 48.0077, longitude: 0.1996 },
  'Amiens': { city: 'Amiens', country: 'France', latitude: 49.8941, longitude: 2.2957 },
  'Tours': { city: 'Tours', country: 'France', latitude: 47.3941, longitude: 0.6848 },
  'Limoges': { city: 'Limoges', country: 'France', latitude: 45.8336, longitude: 1.2611 },
  'Villeurbanne': { city: 'Villeurbanne', country: 'France', latitude: 45.7640, longitude: 4.8794 },
  'Clermont-Ferrand': { city: 'Clermont-Ferrand', country: 'France', latitude: 45.7797, longitude: 3.0863 },
  'Besançon': { city: 'Besançon', country: 'France', latitude: 47.2380, longitude: 6.0243 },
  'Orléans': { city: 'Orléans', country: 'France', latitude: 47.9029, longitude: 1.9093 },
  'Caen': { city: 'Caen', country: 'France', latitude: 49.1829, longitude: -0.3707 },
  'Mulhouse': { city: 'Mulhouse', country: 'France', latitude: 47.7508, longitude: 7.3359 },
  'Rouen': { city: 'Rouen', country: 'France', latitude: 49.4431, longitude: 1.0993 },
  'Nancy': { city: 'Nancy', country: 'France', latitude: 48.6921, longitude: 6.1844 },
  'Argenteuil': { city: 'Argenteuil', country: 'France', latitude: 48.9474, longitude: 2.2476 },
  'Montreuil': { city: 'Montreuil', country: 'France', latitude: 48.8634, longitude: 2.4444 },
  'Roubaix': { city: 'Roubaix', country: 'France', latitude: 50.6942, longitude: 3.1746 },
  'Tourcoing': { city: 'Tourcoing', country: 'France', latitude: 50.7236, longitude: 3.1614 },
  'Nanterre': { city: 'Nanterre', country: 'France', latitude: 48.8917, longitude: 2.2069 },
  'Vitry-sur-Seine': { city: 'Vitry-sur-Seine', country: 'France', latitude: 48.7873, longitude: 2.4039 },
  'Créteil': { city: 'Créteil', country: 'France', latitude: 48.7906, longitude: 2.4555 },
  'Avignon': { city: 'Avignon', country: 'France', latitude: 43.9493, longitude: 4.8055 },
  'Poitiers': { city: 'Poitiers', country: 'France', latitude: 46.5802, longitude: 0.3404 },
  'Echirolles': { city: 'Echirolles', country: 'France', latitude: 45.1453, longitude: 5.7178 },
  
  // Additional French cities from ambassador data
  'Choisy': { city: 'Choisy', country: 'France', latitude: 48.7657, longitude: 2.4138 },
  'Saint-Ouen': { city: 'Saint-Ouen', country: 'France', latitude: 48.9048, longitude: 2.3335 },
  'Aix': { city: 'Aix', country: 'France', latitude: 43.5297, longitude: 5.4474 }, // Aix-en-Provence
  'Metz': { city: 'Metz', country: 'France', latitude: 49.1193, longitude: 6.1757 },
  'Pau': { city: 'Pau', country: 'France', latitude: 43.2951, longitude: -0.3707 },
  'Perpignan': { city: 'Perpignan', country: 'France', latitude: 42.6886, longitude: 2.8948 },
  'Lorient': { city: 'Lorient', country: 'France', latitude: 47.7482, longitude: -3.3603 },
  'Limonest': { city: 'Limonest', country: 'France', latitude: 45.8353, longitude: 4.7733 },
  'Marseille / Corse': { city: 'Marseille / Corse', country: 'France', latitude: 43.2965, longitude: 5.3698 }, // Use Marseille coords
  'Les Abymes': { city: 'Les Abymes', country: 'France', latitude: 16.2650, longitude: -61.5100 }, // Guadeloupe
  'Saint-Denis de la Réunion': { city: 'Saint-Denis de la Réunion', country: 'France', latitude: -20.8823, longitude: 55.4504 }, // Réunion

  // Germany
  'Berlin': { city: 'Berlin', country: 'Germany', latitude: 52.5200, longitude: 13.4050 },
  'Hamburg': { city: 'Hamburg', country: 'Germany', latitude: 53.5511, longitude: 9.9937 },
  'Munich': { city: 'Munich', country: 'Germany', latitude: 48.1351, longitude: 11.5820 },
  'Cologne': { city: 'Cologne', country: 'Germany', latitude: 50.9375, longitude: 6.9603 },
  'Frankfurt': { city: 'Frankfurt', country: 'Germany', latitude: 50.1109, longitude: 8.6821 },
  'Stuttgart': { city: 'Stuttgart', country: 'Germany', latitude: 48.7758, longitude: 9.1829 },
  'Düsseldorf': { city: 'Düsseldorf', country: 'Germany', latitude: 51.2277, longitude: 6.7735 },
  'Dortmund': { city: 'Dortmund', country: 'Germany', latitude: 51.5136, longitude: 7.4653 },
  'Essen': { city: 'Essen', country: 'Germany', latitude: 51.4556, longitude: 7.0116 },
  'Leipzig': { city: 'Leipzig', country: 'Germany', latitude: 51.3397, longitude: 12.3731 },
  'Bremen': { city: 'Bremen', country: 'Germany', latitude: 53.0793, longitude: 8.8017 },
  'Dresden': { city: 'Dresden', country: 'Germany', latitude: 51.0504, longitude: 13.7373 },
  'Hanover': { city: 'Hanover', country: 'Germany', latitude: 52.3759, longitude: 9.7320 },

  // Italy
  'Rome': { city: 'Rome', country: 'Italia', latitude: 41.9028, longitude: 12.4964 },
  'Milan': { city: 'Milan', country: 'Italia', latitude: 45.4642, longitude: 9.1900 },
  'Naples': { city: 'Naples', country: 'Italia', latitude: 40.8518, longitude: 14.2681 },
  'Turin': { city: 'Turin', country: 'Italia', latitude: 45.0703, longitude: 7.6869 },
  'Palermo': { city: 'Palermo', country: 'Italia', latitude: 38.1157, longitude: 13.3613 },
  'Genoa': { city: 'Genoa', country: 'Italia', latitude: 44.4056, longitude: 8.9463 },
  'Bologna': { city: 'Bologna', country: 'Italia', latitude: 44.4949, longitude: 11.3426 },
  'Florence': { city: 'Florence', country: 'Italia', latitude: 43.7696, longitude: 11.2558 },
  'Bari': { city: 'Bari', country: 'Italia', latitude: 41.1171, longitude: 16.8719 },
  'Catania': { city: 'Catania', country: 'Italia', latitude: 37.5079, longitude: 15.0830 },

  // Spain & Portugal
  'Madrid': { city: 'Madrid', country: 'Spain&Portugal', latitude: 40.4168, longitude: -3.7038 },
  'Barcelona': { city: 'Barcelona', country: 'Spain&Portugal', latitude: 41.3851, longitude: 2.1734 },
  'Valencia': { city: 'Valencia', country: 'Spain&Portugal', latitude: 39.4699, longitude: -0.3763 },
  'Seville': { city: 'Seville', country: 'Spain&Portugal', latitude: 37.3891, longitude: -5.9845 },
  'Zaragoza': { city: 'Zaragoza', country: 'Spain&Portugal', latitude: 41.6488, longitude: -0.8891 },
  'Málaga': { city: 'Málaga', country: 'Spain&Portugal', latitude: 36.7213, longitude: -4.4214 },
  'Murcia': { city: 'Murcia', country: 'Spain&Portugal', latitude: 37.9922, longitude: -1.1307 },
  'Palma': { city: 'Palma', country: 'Spain&Portugal', latitude: 39.5696, longitude: 2.6502 },
  'Las Palmas': { city: 'Las Palmas', country: 'Spain&Portugal', latitude: 28.1248, longitude: -15.4300 },
  'Bilbao': { city: 'Bilbao', country: 'Spain&Portugal', latitude: 43.2627, longitude: -2.9253 },
  'Lisbon': { city: 'Lisbon', country: 'Spain&Portugal', latitude: 38.7223, longitude: -9.1393 },
  'Porto': { city: 'Porto', country: 'Spain&Portugal', latitude: 41.1579, longitude: -8.6291 },

  // United Kingdom
  'London': { city: 'London', country: 'UK', latitude: 51.5074, longitude: -0.1278 },
  'Birmingham': { city: 'Birmingham', country: 'UK', latitude: 52.4862, longitude: -1.8904 },
  'Liverpool': { city: 'Liverpool', country: 'UK', latitude: 53.4084, longitude: -2.9916 },
  'Leeds': { city: 'Leeds', country: 'UK', latitude: 53.8008, longitude: -1.5491 },
  'Glasgow': { city: 'Glasgow', country: 'UK', latitude: 55.8642, longitude: -4.2518 },
  'Sheffield': { city: 'Sheffield', country: 'UK', latitude: 53.3811, longitude: -1.4701 },
  'Bradford': { city: 'Bradford', country: 'UK', latitude: 53.7960, longitude: -1.7594 },
  'Edinburgh': { city: 'Edinburgh', country: 'UK', latitude: 55.9533, longitude: -3.1883 },
  'Manchester': { city: 'Manchester', country: 'UK', latitude: 53.4808, longitude: -2.2426 },
  'Bristol': { city: 'Bristol', country: 'UK', latitude: 51.4545, longitude: -2.5879 },

  // Denmark
  'Copenhagen': { city: 'Copenhagen', country: 'Danemark', latitude: 55.6761, longitude: 12.5683 },
  'Aarhus': { city: 'Aarhus', country: 'Danemark', latitude: 56.1629, longitude: 10.2039 },
  'Aalborg': { city: 'Aalborg', country: 'Danemark', latitude: 57.0488, longitude: 9.9217 },
  'Esbjerg': { city: 'Esbjerg', country: 'Danemark', latitude: 55.4707, longitude: 8.4517 },

  // Canada
  'Toronto': { city: 'Toronto', country: 'Canada', latitude: 43.6532, longitude: -79.3832 },
  'Montreal': { city: 'Montreal', country: 'Canada', latitude: 45.5017, longitude: -73.5673 },
  'Vancouver': { city: 'Vancouver', country: 'Canada', latitude: 49.2827, longitude: -123.1207 },
  'Calgary': { city: 'Calgary', country: 'Canada', latitude: 51.0447, longitude: -114.0719 },
  'Edmonton': { city: 'Edmonton', country: 'Canada', latitude: 53.5461, longitude: -113.4938 },
  'Ottawa': { city: 'Ottawa', country: 'Canada', latitude: 45.4215, longitude: -75.6972 },
  'Winnipeg': { city: 'Winnipeg', country: 'Canada', latitude: 49.8951, longitude: -97.1384 },
  'Quebec City': { city: 'Quebec City', country: 'Canada', latitude: 46.8139, longitude: -71.2080 },
  'Sherbrooke': { city: 'Sherbrooke', country: 'Canada', latitude: 45.4042, longitude: -71.8929 },

  // Malaysia
  'Kuala Lumpur': { city: 'Kuala Lumpur', country: 'Malaysia', latitude: 3.1390, longitude: 101.6869 },
  'George Town': { city: 'George Town', country: 'Malaysia', latitude: 5.4164, longitude: 100.3327 },
  'Ipoh': { city: 'Ipoh', country: 'Malaysia', latitude: 4.5975, longitude: 101.0901 },
  'Shah Alam': { city: 'Shah Alam', country: 'Malaysia', latitude: 3.0733, longitude: 101.5185 },
  'Petaling Jaya': { city: 'Petaling Jaya', country: 'Malaysia', latitude: 3.1073, longitude: 101.6058 },

  // Morocco
  'Casablanca': { city: 'Casablanca', country: 'Maroc', latitude: 33.5731, longitude: -7.5898 },
  'Rabat': { city: 'Rabat', country: 'Maroc', latitude: 34.0209, longitude: -6.8416 },
  'Rabah': { city: 'Rabah', country: 'Maroc', latitude: 34.0209, longitude: -6.8416 }, // Alternative spelling
  'Fez': { city: 'Fez', country: 'Maroc', latitude: 34.0181, longitude: -5.0078 },
  'Marrakech': { city: 'Marrakech', country: 'Maroc', latitude: 31.6295, longitude: -7.9811 },
  'Agadir': { city: 'Agadir', country: 'Maroc', latitude: 30.4202, longitude: -9.5982 },
  'Tangier': { city: 'Tangier', country: 'Maroc', latitude: 35.7595, longitude: -5.8340 },
  'Meknes': { city: 'Meknes', country: 'Maroc', latitude: 33.8935, longitude: -5.5473 },

  // Vietnam
  'Ho Chi Minh': { city: 'Ho Chi Minh', country: 'Vietnam', latitude: 10.8231, longitude: 106.6297 },
  'Hi Chi Minh': { city: 'Hi Chi Minh', country: 'Vietnam', latitude: 10.8231, longitude: 106.6297 }, // Alternative spelling
  'Ho CHi Minh': { city: 'Ho CHi Minh', country: 'Vietnam', latitude: 10.8231, longitude: 106.6297 }, // Alternative spelling
  'Hanoi': { city: 'Hanoi', country: 'Vietnam', latitude: 21.0285, longitude: 105.8542 },

  // Thailand
  'Bangkok': { city: 'Bangkok', country: 'Thailand', latitude: 13.7563, longitude: 100.5018 },

  // Indonesia
  'Jakarta': { city: 'Jakarta', country: 'Indonesia', latitude: -6.2088, longitude: 106.8456 },

  // Philippines
  'Manila': { city: 'Manila', country: 'Philippines', latitude: 14.5995, longitude: 120.9842 },
  'Manille': { city: 'Manille', country: 'Philippines', latitude: 14.5995, longitude: 120.9842 }, // French spelling

  // Denmark (fix country name mismatch)
  'Copenhagen': { city: 'Copenhagen', country: 'Danemark', latitude: 55.6761, longitude: 12.5683 },
  'Copenhague': { city: 'Copenhague', country: 'Danemark', latitude: 55.6761, longitude: 12.5683 }, // French spelling
  'Aarhus': { city: 'Aarhus', country: 'Danemark', latitude: 56.1629, longitude: 10.2039 },
  'Aalborg': { city: 'Aalborg', country: 'Danemark', latitude: 57.0488, longitude: 9.9217 },
  'Esbjerg': { city: 'Esbjerg', country: 'Danemark', latitude: 55.4707, longitude: 8.4517 },
};

/**
 * Get coordinates for a city, with fallback handling
 */
export function getCityCoordinates(city: string, country: string): CityCoordinate | null {
  // Handle null/undefined cities
  if (!city || !country) {
    return null;
  }

  // Try exact city match first
  const exactMatch = CITY_COORDINATES[city];
  if (exactMatch && exactMatch.country === country) {
    return exactMatch;
  }

  // Try case-insensitive match
  const cityKey = Object.keys(CITY_COORDINATES).find(
    key => key.toLowerCase() === city.toLowerCase()
  );
  
  if (cityKey) {
    const match = CITY_COORDINATES[cityKey];
    if (match.country === country) {
      return match;
    }
  }

  // Return null if no match found
  return null;
}

/**
 * Get country center coordinates for fallback positioning
 */
export function getCountryCenter(country: string): CityCoordinate | null {
  const countryCapitals: Record<string, CityCoordinate> = {
    'France': { city: 'Paris', country: 'France', latitude: 48.8566, longitude: 2.3522 },
    'Germany': { city: 'Berlin', country: 'Germany', latitude: 52.5200, longitude: 13.4050 },
    'Italia': { city: 'Rome', country: 'Italia', latitude: 41.9028, longitude: 12.4964 },
    'Spain&Portugal': { city: 'Madrid', country: 'Spain&Portugal', latitude: 40.4168, longitude: -3.7038 },
    'UK': { city: 'London', country: 'UK', latitude: 51.5074, longitude: -0.1278 },
    'Danemark': { city: 'Copenhagen', country: 'Danemark', latitude: 55.6761, longitude: 12.5683 },
    'Canada': { city: 'Ottawa', country: 'Canada', latitude: 45.4215, longitude: -75.6972 },
    'Malaysia': { city: 'Kuala Lumpur', country: 'Malaysia', latitude: 3.1390, longitude: 101.6869 },
    'Maroc': { city: 'Casablanca', country: 'Maroc', latitude: 33.5731, longitude: -7.5898 },
    'Vietnam': { city: 'Ho Chi Minh', country: 'Vietnam', latitude: 10.8231, longitude: 106.6297 },
    'Thailand': { city: 'Bangkok', country: 'Thailand', latitude: 13.7563, longitude: 100.5018 },
    'Indonesia': { city: 'Jakarta', country: 'Indonesia', latitude: -6.2088, longitude: 106.8456 },
    'Philippines': { city: 'Manila', country: 'Philippines', latitude: 14.5995, longitude: 120.9842 },
  };

  return countryCapitals[country] || null;
}

/**
 * Add coordinates to ambassador data with fallback handling
 */
export function enrichAmbassadorWithCoordinates(ambassador: any): any {
  // Handle ambassadors with missing location data
  if (!ambassador.city && !ambassador.country) {
    return ambassador; // Skip geocoding if no location data
  }

  const coordinates = getCityCoordinates(ambassador.city, ambassador.country);
  
  if (coordinates) {
    return {
      ...ambassador,
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
    };
  }

  // Fallback to country center
  const countryCenter = getCountryCenter(ambassador.country);
  if (countryCenter) {
    return {
      ...ambassador,
      latitude: countryCenter.latitude,
      longitude: countryCenter.longitude,
    };
  }

  // Last fallback - center of Europe
  return {
    ...ambassador,
    latitude: 50.0755, // Brussels, Belgium
    longitude: 4.4357,
  };
}

/**
 * Get all unique cities from the coordinate database
 */
export function getAllCities(): CityCoordinate[] {
  return Object.values(CITY_COORDINATES);
}

/**
 * Calculate bounding box for a set of coordinates
 */
export function calculateBounds(coordinates: { latitude: number; longitude: number }[]): {
  north: number;
  south: number;
  east: number;
  west: number;
} {
  if (coordinates.length === 0) {
    // Default to Europe bounds
    return {
      north: 70.0,
      south: 35.0,
      east: 30.0,
      west: -10.0,
    };
  }

  const lats = coordinates.map(coord => coord.latitude);
  const lngs = coordinates.map(coord => coord.longitude);

  return {
    north: Math.max(...lats),
    south: Math.min(...lats),
    east: Math.max(...lngs),
    west: Math.min(...lngs),
  };
}